import { useCallback } from 'react';
import get from 'lodash/get';

export default watchedPropsArray => {
  if (!Array.isArray(watchedPropsArray)) {
    console.error(
      `useFastFieldShouldRenderFn should receive an array as an argument. Got ${watchedPropsArray} of type ${typeof watchedPropsArray}`
    );
  }

  // Replicates the checks in FastFields, and adds the "options" prop
  // to the check.
  // https://github.com/jaredpalmer/formik/blob/master/packages/formik/src/FastField.tsx#L75-L93
  return useCallback(
    (nextProps, currentProps) => {
      const hasDifferent = formikStatePart =>
        get(nextProps.formik[formikStatePart], currentProps.name) !==
        get(currentProps.formik[formikStatePart], currentProps.name);

      return (
        nextProps.name !== currentProps.name ||
        watchedPropsArray.some(
          prop => nextProps[prop] !== currentProps[prop]
        ) ||
        nextProps.options !== currentProps.options ||
        hasDifferent('values') ||
        hasDifferent('errors') ||
        hasDifferent('touched') ||
        hasDifferent('isSubmitting') ||
        Object.keys(currentProps).length !== Object.keys(nextProps).length
      );
    },
    [watchedPropsArray]
  );
};
